import { render, staticRenderFns } from "./NewProducts.vue?vue&type=template&id=18392d30&scoped=true&"
import script from "./NewProducts.vue?vue&type=script&lang=js&"
export * from "./NewProducts.vue?vue&type=script&lang=js&"
import style0 from "./NewProducts.vue?vue&type=style&index=0&id=18392d30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18392d30",
  null
  
)

export default component.exports